import Vue from "vue";
import Vuex from "vuex";
import ef from "./ef";
import menu from "./menu";
import waste from "./waste";
import dashboard from "./dashboard";
import register from "./register";
import selectLang from "./selectLang";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    companyId: "",
    companyName: "",
    role: "",
    company_image_url: null,
    admin_type: null,
    setup_type: null,
    main_company: null,
    role_action: null,
    // secoundEf : 1
    permissions: null,
    company_data: null,
    access_from: "",
    oauth_token: null,
    oauth_refresh_token: null,
  },
  mutations: {
    setOAuthToken: (state, payload) => {
      state.oauth_token = payload;
    },
    setOAuthRefreshToken: (state, payload) => {
      state.oauth_refresh_token = payload;
    },
    setMainCompany: (state, payload) => {
      state.main_company = payload;
    },
    setCompanyId: (state, payload) => {
      state.companyId = payload;
    },
    setCompanyName: (state, payload) => {
      state.companyName = payload;
    },
    setRoleId: (state, payload) => {
      state.role = payload;
    },
    setCompanyImage: (state, payload) => {
      state.company_image_url = payload;
    },
    setAdminType: (state, payload) => {
      state.admin_type = payload;
    },
    setUpType: (state, payload) => {
      state.setup_type = payload;
    },
    setRoleAction: (state, payload) => {
      state.role_action = payload;
    },
    setToken: (state, payload) => {
      state.token = payload;
    },
    // setSecoundEf : (state, payload) => {
    //   state.secoundEf = payload;
    // },
    setPermission: (state, payload) => {
      state.permissions = payload;
    },
    setCompanyData: (state, payload) => {
      state.company_data = payload;
    },
    setAccessFrom: (state, payload) => {
      state.access_from = payload;
    },
  },
  actions: {
    setOAuthToken: (state, payload) => {
      state.commit("setOAuthToken", payload);
    },
    setOAuthRefreshToken: (state, payload) => {
      state.commit("setOAuthRefreshToken", payload);
    },
    setMainCompany: (state, payload) => {
      state.commit("setMainCompany", payload);
    },
    setToken: (state, payload) => {
      state.commit("setToken", payload);
    },
    setCompanyId: (state, payload) => {
      state.commit("setCompanyId", payload);
    },
    setCompanyName: (state, payload) => {
      state.commit("setCompanyName", payload);
    },
    setRoleId: (state, payload) => {
      state.commit("setRoleId", payload);
    },
    setCompanyImage: (state, payload) => {
      state.commit("setCompanyImage", payload);
    },
    setAdminType: (state, payload) => {
      state.commit("setAdminType", payload);
    },
    setUpType: (state, payload) => {
      state.commit("setUpType", payload);
    },
    setRoleAction: (state, payload) => {
      state.commit("setRoleAction", payload);
    },
    // setSecoundEf : (state, payload) => {
    //   state.commit("setSecoundEf", payload);
    // },
    setPermission: (state, payload) => {
      state.commit("setPermission", payload);
    },

    setPermissionLogin: (state, payload) => {
      state.commit("setPermission", payload);
    },

    setCompanyData: (state, payload) => {
      state.commit("setCompanyData", payload);
    },

    setAccessFrom: (state, payload) => {
      state.commit("setAccessFrom", payload);
    },

    async getPermission({ state, dispatch }) {
      const permissions = state.main_company.page_permission;
      await dispatch("setPermission", permissions);
    },
  },
  modules: {
    ef,
    menu,
    register,
    dashboard,
    selectLang,
    waste,
  },
  getters: {
    getToken: (state) => state.token,
    getCompanyId: (state) => state.companyId,
    getCompanyName: (state) => state.companyName,
    getRoleId: (state) => state.role,
    getPermissions: (state) => state.permissions,
  },
  plugins: [createPersistedState()],
});

// export default store;
